<template>
  <el-dropdown
    @command="sortItems"
    class="orderSortDropDown"
    popper-class="orderSortDropDown"
  >
    <span class="dropDownHeader">
      {{ text }}
      <i class="el-icon-arrow-down" />
    </span>
    <template #dropdown>
      <el-dropdown-menu>
        <el-dropdown-item :command="descCommand">
          <div class="flex dropDownSelect">
            <span>
              <i
                v-show="isDescSelected"
                class="el-icon-check"
              />
            </span>
            <div>
              降順
            </div>
          </div>
        </el-dropdown-item>
        <el-dropdown-item :command="ascCommand">
          <div class="flex dropDownSelect">
            <span>
              <i
              v-show="isAscSelected"
              class="el-icon-check"
            />
            </span>
            <div>
              昇順
            </div>
          </div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>

<script>
export default {
  props: {
    text: {
      tyep: String,
      default: "",
    },
    sortKey: {
      tyep: String,
      default: "",
    },
    sortParams: {
      type: Object,
      default: () => {
        return {
          sortKey: "",
          sortDirection: "",
        };
      },
    },
  },
  components: {},
  computed: {
    descCommand () {
      return `${this.sortKey}:DESC`;
    },
    ascCommand () {
      return `${this.sortKey}:ASC`;
    },
    isDescSelected () {
      if (this.sortKey === this.sortParams.sortKey) {
        return this.sortParams.sortDirection === "DESC";
      }
      return false;
    },
    isAscSelected () {
      if (this.sortKey === this.sortParams.sortKey) {
        return this.sortParams.sortDirection === "ASC";
      }
      return false;
    },
  },
  methods: {
    // sort items
    sortItems (commandValue) {
      const sortParams = commandValue.split(":");
      this.$emit("updateSortDirection", {
        sortKey: sortParams[0],
        sortDirection: sortParams[1],
      });
    },
    checkSelectedSortType (sortDirection) {
      console.log("this.sortParams.", this.sortParams);
      // ソート対象かどうか
      if (this.sortKey === this.sortParams.sortKey) {
        return this.sortParams.sortKey === sortDirection;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.orderSortDropDown {
  height: 36px;
}
.dropDownHeader {
  font-size: 0.75rem;
  color: $text-extra-light;
}

.dropDownSelect {
  > span {
    display: block;
    width: 20px;
  }
}
</style>
